<template>
    <LayoutSub className="company_content">
        <SubSection>
            <h1>KICC의 로고는 <span class="c-red">도전, 소통, 개방</span>의 <br>의미를 담은 KICC의 대표 아이덴티티입니다.</h1>
        </SubSection>
        <section class="ci_section" data-aos="fade-up">
            <div class="ci_image_wrap">
                <img src="@/assets/ci_section_bg.png" alt="" />
            </div>
            <div class="ci_button_wrap">
                <RedLineButton text="CI 다운로드" type="download" link="/kicc_logo_CI.zip" />
            </div>
        </section>
        <SubSection class="pb-0">
            <h2>Color System</h2>
            <div class="color_system_wrap">
                <div class="color_system_block red">
                    <p class="color_name">KICC Red</p>
                    <p class="color_desc">도전적이고 강한 이미지를 전달합니다.</p>
                    <div class="color_infor">
                        <pre>
HEX   #e0012b
R 224    G 1    B 43
C 4    M 100    Y 82    K 0
</pre>
                    </div>
                </div>
                <div class="color_system_block orange">
                    <p class="color_name">KICC Orange</p>
                    <p class="color_desc">커뮤니케이션과 승리를 위한 소통과 개방을 의미합니다.</p>
                    <div class="color_infor">
                        <pre>
HEX   #ee8500
R 238    G 133    B 0
C 0    M 58    Y 100    K 0
</pre>
                    </div>
                </div>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import RedLineButton from '@/components/RedLineButton.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        RedLineButton,
    },
};
</script>